<template>
  <asc-navbar-button
    icon="mdi-account"
    :primary-items="getItems"
    :width="250"
    :text="getInitials"
  ></asc-navbar-button>
</template>

<script>
import AscNavbarButton from './AscNavbarButton'
import { profileNameInitials } from '@/utilities/profile'
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'
import { PERMISSION_LEVEL_CONSTS as PLC } from '@/stores/consts'

export default {
  name: 'AscUserAccountButton',

  components: {
    AscNavbarButton,
  },

  props: {
    profile: {
      type: Object,
      default: () => {},
    },
    onLogOut: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      airlineAdminPermission: {
        name: RESOURCES.AIRLINE_ADMIN,
        permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
      },
    }
  },

  computed: {
    getProfileName() {
      const firstName = this.profile?.firstName ? this.profile.firstName : ''
      const lastName = this.profile?.lastName ? this.profile.lastName : ''
      return `${firstName} ${lastName}`
    },

    getInitials() {
      const profileName = this.getProfileName
      const initials = profileNameInitials(profileName)
      return initials
    },

    getProfileEmail() {
      return this.profile?.userEmail ? this.profile.userEmail : ''
    },

    getProfileJobTitle() {
      return ''
    },

    getSubscriptionCenterRoute() {
      return this.profile?.roles.map(r => r.name).includes('AcmfUser') ||
        this.profile?.roles.map(r => r.name).includes('AirlineUser')
        ? [{ title: 'Subscription Center', to: '/user/subscription-center' }]
        : []
    },

    getUserProfileRoute() {
      return [{ title: 'User Profile', to: '/user/profile' }]
    },

    getCollinsAdminRoute() {
      return this.isCollinsAdmin()
        ? [{ title: 'Collins Admin', to: '/admin' }]
        : []
    },
    getAirlineAdminRoute() {
      return this.validatePermissions([this.airlineAdminPermission])
        ? [{ title: 'Admin', href: this.createVue3Route('airline-admin') }]
        : []
    },
    getItems() {
      return [
        {
          isText: true,
          text: this.getProfileName,
          size: 'lg',
          color: '#000',
          topPadding: true,
        },
        {
          isText: true,
          text: this.getProfileEmail,
          size: 'sm',
          color: '#848484',
        },
        {
          isText: true,
          text: this.getProfileJobTitle,
          size: 'sm',
          color: '#848484',
          bottomPadding: true,
        },
        { isSeparator: true },
        ...this.getUserProfileRoute,
        ...this.getSubscriptionCenterRoute,
        ...this.getCollinsAdminRoute,
        ...this.getAirlineAdminRoute,
        { isSeparator: true },
        {
          isText: true,
          text: 'Help & Policies',
          size: 'sm',
          color: '#848484',
          uppercase: true,
          topPadding: true,
        },
        { title: 'Help & About', to: '/user/help' },
        { title: 'Release Notes', to: '/user/release-notes' },
        { title: 'Terms & Conditions', to: '/user/terms' },
        { isSeparator: true },
        { title: 'Log Out', onClick: this.onLogOut },
      ]
    },
  },

  methods: {
    validatePermissions(permissions) {
      if (!permissions) {
        return true
      }

      let permissionSatisfied = false
      if (this.profile?.permissions) {
        for (const permission of permissions) {
          if (
            this.profile.permissions.find(
              item =>
                item.name == permission.name &&
                this.verifyLevel(
                  item.permissionLevel,
                  permission.permissionLevel,
                ),
            )
          ) {
            permissionSatisfied = true
            break
          }
        }
      }
      return permissionSatisfied
    },
    verifyLevel(userLevel, requiredLevel) {
      if (userLevel < requiredLevel) {
        return false
      }

      //Anything > 4 has to have delete
      if (requiredLevel === PLC.DELETE) {
        return userLevel >= PLC.DELETE
      }

      //Edit gets weird because 5 is a valid number.
      //Subtract the 4 to remove 5 from the equation and anything > 2 must be fine.
      if (requiredLevel === PLC.EDIT) {
        let tempLevel = userLevel
        if (userLevel >= 4) {
          tempLevel -= 4
        }
        return tempLevel >= PLC.EDIT
      }

      //Read will always be odd
      return userLevel % 2 === PLC.READ
    },
    isCollinsAdmin() {
      if (this.profile?.roles)
        return (
          this.profile.roles.map(r => r.name).includes('AnalyticAdmin') ||
          this.profile.roles.map(r => r.name).includes('DocumentManager') ||
          this.profile.roles.map(r => r.name).includes('AirlineManager') ||
          this.profile.roles.map(r => r.name).includes('UserManager') ||
          this.profile.roles.map(r => r.name).includes('UserReader')
        )
    },
    createVue3Route(route) {
      const protocol = window.location.protocol
      const mainPath = window.location.hostname

      let fullAddress = `${mainPath}/${process.env.BASE_URL}vue3/${route}`
      fullAddress = fullAddress.replace('//', '/')
      fullAddress = `${protocol}//${fullAddress}`

      if (process.env.VUE_APP_VUE3_URL) {
        fullAddress = `${process.env.BASE_URL}/${route}`
        fullAddress = fullAddress.replace('//', '/')
        fullAddress = `${process.env.VUE_APP_VUE3_URL}${fullAddress}`
      }
      return fullAddress
    },
  },
}
</script>
